export const STORE_KEY = '@@order'
export const GET_STORE_ORDER_REQUEST = `${STORE_KEY}/GET_STORE_ORDER_REQUEST`
export const GET_STORE_ORDER_SUCCESS = `${STORE_KEY}/GET_STORE_ORDER_SUCCESS`
export const GET_STORE_ORDER_FAILURE = `${STORE_KEY}/GET_STORE_ORDER_FAILURE`
export const GET_ELIGIBLE_PROMO_REQUEST = `${STORE_KEY}/GET_ELIGIBLE_PROMO_REQUEST`
export const GET_ELIGIBLE_PROMO_SUCCESS = `${STORE_KEY}/GET_ELIGIBLE_PROMO_SUCCESS`
export const GET_ELIGIBLE_PROMO_FAILURE = `${STORE_KEY}/GET_ELIGIBLE_PROMO_FAILURE`
export const UPDATE_STORE_ORDER_ITEM_QUANTITY_REQUEST = `${STORE_KEY}/UPDATE_STORE_ORDER_ITEM_QUANTITY_REQUEST`
export const UPDATE_STORE_ORDER_ITEM_QUANTITY_SUCCESS = `${STORE_KEY}/UPDATE_STORE_ORDER_ITEM_QUANTITY_SUCCESS`
export const UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_SUCCESS = `${STORE_KEY}/UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_SUCCESS`
export const UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_BACKUP = `${STORE_KEY}/UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_BACKUP`
export const UPDATE_STORE_ORDER_ITEM_QUANTITY_FAILURE = `${STORE_KEY}/UPDATE_STORE_ORDER_ITEM_QUANTITY_FAILURE`
export const ADD_TO_CART_REQUEST = `${STORE_KEY}/ADD_TO_CART_REQUEST`
export const ADD_TO_CART_SUCCESS = `${STORE_KEY}/ADD_TO_CART_SUCCESS`
export const ADD_TO_CART_FAILURE = `${STORE_KEY}/ADD_TO_CART_FAILURE`
export const CLEAR_CART_REQUEST = `${STORE_KEY}/CLEAR_CART_REQUEST`
export const CLEAR_CART_SUCCESS = `${STORE_KEY}/CLEAR_CART_SUCCESS`
export const CLEAR_CART_FAILURE = `${STORE_KEY}/CLEAR_CART_FAILURE`
export const CHANGE_DELIVERY_STEP = `${STORE_KEY}/CHANGE_DELIVERY_STEP`
export const CHANGE_PICKUP_STEP = `${STORE_KEY}/CHANGE_PICKUP_STEP`
export const CHANGE_CHECKOUT_STEP = `${STORE_KEY}/CHANGE_CHECKOUT_STEP`
export const GET_TIME_SLOTS_REQUEST = `${STORE_KEY}/GET_TIME_SLOTS_REQUEST`
export const GET_TIME_SLOTS_SUCCESS = `${STORE_KEY}/GET_TIME_SLOTS_SUCCESS`
export const GET_TIME_SLOTS_FAILURE = `${STORE_KEY}/GET_TIME_SLOTS_FAILURE`
export const SYNC_METHOD_REQUEST = `${STORE_KEY}/SYNC_METHOD_REQUEST`
export const SYNC_METHOD_SUCCESS = `${STORE_KEY}/SYNC_METHOD_SUCCESS`
export const SYNC_METHOD_FAILURE = `${STORE_KEY}/SYNC_METHOD_FAILURE`
export const SYNC_PICKUP_LOCATION_REQUEST = `${STORE_KEY}/SYNC_PICKUP_LOCATION_REQUEST`
export const SYNC_PICKUP_LOCATION_SUCCESS = `${STORE_KEY}/SYNC_PICKUP_LOCATION_SUCCESS`
export const SYNC_PICKUP_LOCATION_FAILURE = `${STORE_KEY}/SYNC_PICKUP_LOCATION_FAILURE`
export const SYNC_DELIVERY_LOCATION_REQUEST = `${STORE_KEY}/SYNC_DELIVERY_LOCATION_REQUEST`
export const SYNC_DELIVERY_LOCATION_SUCCESS = `${STORE_KEY}/SYNC_DELIVERY_LOCATION_SUCCESS`
export const SYNC_DELIVERY_LOCATION_FAILURE = `${STORE_KEY}/SYNC_DELIVERY_LOCATION_FAILURE`
export const SYNC_DELIVERY_ADDRESS_TWO_REQUEST = `${STORE_KEY}/SYNC_DELIVERY_ADDRESS_TWO_REQUEST`
export const SYNC_DELIVERY_ADDRESS_TWO_SUCCESS = `${STORE_KEY}/SYNC_DELIVERY_ADDRESS_TWO_SUCCESS`
export const SYNC_DELIVERY_ADDRESS_TWO_FAILURE = `${STORE_KEY}/SYNC_DELIVERY_ADDRESS_TWO_FAILURE`
export const SYNC_COLLECTION_TIME_REQUEST = `${STORE_KEY}/SYNC_COLLECTION_TIME_REQUEST`
export const SYNC_COLLECTION_TIME_SUCCESS = `${STORE_KEY}/SYNC_COLLECTION_TIME_SUCCESS`
export const SYNC_COLLECTION_TIME_FAILURE = `${STORE_KEY}/SYNC_COLLECTION_TIME_FAILURE`
export const APPLY_PROMOTIONS_REQUEST = `${STORE_KEY}/APPLY_PROMOTIONS_REQUEST`
export const APPLY_PROMOTIONS_SUCCESS = `${STORE_KEY}/APPLY_PROMOTIONS_SUCCESS`
export const APPLY_PROMOTIONS_FAILURE = `${STORE_KEY}/APPLY_PROMOTIONS_FAILURE`
export const APPLY_PROMO_CODE_REQUEST = `${STORE_KEY}/APPLY_PROMO_CODE_REQUEST`
export const APPLY_PROMO_CODE_SUCCESS = `${STORE_KEY}/APPLY_PROMO_CODE_SUCCESS`
export const APPLY_PROMO_CODE_FAILURE = `${STORE_KEY}/APPLY_PROMO_CODE_FAILURE`
export const TOGGLE_PROMOTION = `${STORE_KEY}/TOGGLE_PROMOTION`
export const PREPARE_CHECKOUT_REQUEST = `${STORE_KEY}/PREPARE_CHECKOUT_REQUEST`
export const PREPARE_CHECKOUT_SUCCESS = `${STORE_KEY}/PREPARE_CHECKOUT_SUCCESS`
export const PREPARE_CHECKOUT_FAILURE = `${STORE_KEY}/PREPARE_CHECKOUT_FAILURE`
export const RESET_APPOINTMENT_ACTION = `${STORE_KEY}/RESET_APPOINTMENT_ACTION`
